import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["data-type", "data-width", "data-rowpos"];
const _hoisted_2 = ["href", "target", "aria-label"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "sh-spotlight-content" };
const _hoisted_5 = { class: "sh-spotlight-title" };
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = ["href", "target", "aria-label"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = { class: "sh-spotlight-content" };
const _hoisted_10 = { class: "sh-spotlight-title" };
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = { class: "sh-stdCell-title" };
const _hoisted_13 = { "aria-hidden": "true" };
const _hoisted_14 = ["href", "target", "aria-label"];
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = {
    key: 1,
    class: "sh-stdCell-links",
    role: "presentation"
};
const _hoisted_17 = ["href", "target"];
import { ThemeButton, ThemeIcon } from '../../../front/components';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Cell',
    props: {
        cell: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            var _a, _b;
            return (_openBlock(), _createElementBlock("section", {
                class: "sh-panelCell",
                "data-type": _ctx.cell.type,
                "data-width": _ctx.cell.width,
                "data-rowpos": _ctx.cell.rowPosition
            }, [
                (_ctx.cell.type === 'spotlight-full' && _ctx.cell.entry)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: _normalizeClass(["sh-spotlight size--full", {
                                'with--image': _ctx.cell.entry.bgImage,
                                [`accentColor--${_ctx.cell.accentColor}`]: _ctx.cell.accentColor
                            }]),
                        href: _ctx.cell.entry.url,
                        target: _ctx.cell.entry.target,
                        "aria-label": `${_ctx.cell.entry.title}: ${_ctx.cell.entry.ctaText || 'Läs mer'}`
                    }, [
                        _createElementVNode("div", {
                            class: "sh-spotlight-bg",
                            innerHTML: (_a = _ctx.cell.entry.bgImage) === null || _a === void 0 ? void 0 : _a.html[_ctx.cell.width === '1/3' ? 'medium' : 'large']
                        }, null, 8, _hoisted_3),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.cell.entry.title), 1),
                            (_ctx.cell.entry.description)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "sh-spotlight-descr",
                                    innerHTML: _ctx.cell.entry.description
                                }, null, 8, _hoisted_6))
                                : _createCommentVNode("", true)
                        ]),
                        _createVNode(_unref(ThemeButton), {
                            tagname: "span",
                            class: "sh-spotlight-ctaBtn",
                            icon: "arrow-right-long",
                            size: "small",
                            title: `${_ctx.cell.entry.ctaText || 'Läs mer'}`
                        }, null, 8, ["title"])
                    ], 10, _hoisted_2))
                    : (_ctx.cell.type === 'spotlight-half')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.cell.children, (cellEntry) => {
                            var _a;
                            return (_openBlock(), _createElementBlock("a", {
                                key: cellEntry.id,
                                class: _normalizeClass(["sh-spotlight size--half", {
                                        'with--image': cellEntry.bgImage,
                                        [`accentColor--${cellEntry.accentColor}`]: _ctx.cell.accentColor
                                    }]),
                                href: cellEntry.url,
                                target: cellEntry.target,
                                "aria-label": `${cellEntry.title}: ${cellEntry.ctaText || 'Läs mer'}`
                            }, [
                                _createElementVNode("div", {
                                    class: "sh-spotlight-bg",
                                    innerHTML: (_a = cellEntry.bgImage) === null || _a === void 0 ? void 0 : _a.html[_ctx.cell.width === '1/3' ? 'medium' : 'large']
                                }, null, 8, _hoisted_8),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(cellEntry.title), 1),
                                    (cellEntry.description)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "sh-spotlight-descr",
                                            innerHTML: cellEntry.description
                                        }, null, 8, _hoisted_11))
                                        : _createCommentVNode("", true)
                                ]),
                                _createVNode(_unref(ThemeButton), {
                                    tagname: "span",
                                    class: "sh-spotlight-ctaBtn",
                                    icon: "arrow-right-long",
                                    size: "small",
                                    title: `${cellEntry.ctaText || 'Läs mer'}`
                                }, null, 8, ["title"])
                            ], 10, _hoisted_7));
                        }), 128))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(["sh-stdCell", { [`accentColor--${_ctx.cell.accentColor}`]: _ctx.cell.accentColor }])
                        }, [
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.cell.entry.title), 1),
                                _createVNode(_unref(ThemeIcon), { name: "arrow-right-long" }),
                                _createElementVNode("a", {
                                    href: _ctx.cell.entry.url,
                                    target: _ctx.cell.entry.target,
                                    "aria-label": `Besök sidan ${_ctx.cell.entry.title}`
                                }, "Besök sidan", 8, _hoisted_14)
                            ]),
                            (_ctx.cell.entry.description)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "sh-stdCell-descr",
                                    innerHTML: _ctx.cell.entry.description
                                }, null, 8, _hoisted_15))
                                : _createCommentVNode("", true),
                            ((_b = _ctx.cell.children) === null || _b === void 0 ? void 0 : _b.length)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cell.children, (subEntry) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: subEntry.id,
                                            role: "presentation"
                                        }, [
                                            _createElementVNode("a", {
                                                class: _normalizeClass({ [`is--${subEntry.locationRelation}`]: subEntry.locationRelation }),
                                                href: subEntry.url,
                                                target: subEntry.target
                                            }, _toDisplayString(subEntry.title), 11, _hoisted_17)
                                        ]));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true)
                        ], 2))
            ], 8, _hoisted_1));
        };
    }
});
